module.exports = __webpack_public_path__ + "static/media/list-bullets.26411967.svg";